import { AccountForm } from '../components/account-form';

export function MyAccount() {
  return (
    <div className="grid gap-6">
      <AccountForm />
    </div>
  );
}
